export default __webpack_public_path__ + "static/media/spring.5a287f1b.jpg";